<template>
  <b-card>
    <validation-observer
      ref="userUpdateForm"
      #default="{ invalid }"
    >
      <!-- form -->
      <b-form
        class="mt-2"
        @submit.prevent="submit"
      >
        <b-row>
          <b-col sm="6">
            <b-form-group
              :label="$t('Bank account owner')"
              label-for="bank_account_owner"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Bank account owner')"
                vid="bank_account_owner"
                rules="required"
              >
                <b-form-input
                  v-model="form.bank_account_owner"
                  :placeholder="$t('Bank account owner')"
                  name="bank_account_owner"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="$t('Bank account number')"
              label-for="bank_account_number"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Bank account number')"
                vid="bank_account_number"
                rules="required"
              >
                <b-form-input
                  v-model="form.bank_account_number"
                  :placeholder="$t('Bank account number')"
                  name="bank_account_number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="$t('Bank account card number')"
              label-for="bank_account_card_number"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Bank account card number')"
                vid="bank_account_card_number"
                rules="required"
              >
                <b-form-input
                  v-model="form.bank_account_card_number"
                  :placeholder="$t('Bank account card number')"
                  name="bank_account_card_number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="$t('Bank account sheba number')"
              label-for="bank_account_sheba_number"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Bank account sheba number')"
                vid="bank_account_sheba_number"
                rules="required"
              >
                <b-form-input
                  v-model="form.bank_account_sheba_number"
                  :placeholder="$t('Bank account sheba number')"
                  name="bank_account_sheba_number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              class="mt-2 mr-1"
              :disabled="invalid"
            >
              {{ $t('Save changes') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              type="reset"
              class="mt-2"
              @click.prevent="resetForm"
            >
              {{ $t('Reset') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        bank_account_owner: null,
        bank_account_number: null,
        bank_account_card_number: null,
        bank_account_sheba_number: null,
        financial: 1,
      },
      // validation rules
      required,
    }
  },
  created() {
    this.resetForm()
  },
  methods: {
    submit() {
      this.$refs.userUpdateForm.validate().then(success => {
        if (success) {
          return this.$emit('onFormSubmit', this.form)
        }
        return success
      })
    },
    resetForm() {
      this.form = {

        bank_account_owner: this.generalData.bank_account_owner,
        bank_account_number: this.generalData.bank_account_number,
        bank_account_card_number: this.generalData.bank_account_card_number,
        bank_account_sheba_number: this.generalData.bank_account_sheba_number,
        financial: 1,
      }
    },
  },
}
</script>
